// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file capability.proto (package evenplay.capability.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file capability.proto.
 */
export const file_capability: GenFile = /*@__PURE__*/
  fileDesc("ChBjYXBhYmlsaXR5LnByb3RvEhZldmVucGxheS5jYXBhYmlsaXR5LnYxIpQBCg9DYXBhYmlsaXR5U3RhdGUSNgoKY2FwYWJpbGl0eRgBIAEoDjIiLmV2ZW5wbGF5LmNhcGFiaWxpdHkudjEuQ2FwYWJpbGl0eRIPCgdlbmFibGVkGAIgASgIEjgKBnNvdXJjZRgDIAEoDjIoLmV2ZW5wbGF5LmNhcGFiaWxpdHkudjEuQ2FwYWJpbGl0eVNvdXJjZSqlAQoKQ2FwYWJpbGl0eRIaChZDQVBBQklMSVRZX1VOU1BFQ0lGSUVEEAASGwoXQ0FQQUJJTElUWV9TS0lMTF9TVFJJS0UQARIgChxDQVBBQklMSVRZX1JFQUxfTU9ORVlfR0FNSU5HEAISIAocQ0FQQUJJTElUWV9GVUxMX1NXSU5HX1BPSU5UUxADEhoKFkNBUEFCSUxJVFlfVE9VUk5BTUVOVFMQBCqwAQoQQ2FwYWJpbGl0eVNvdXJjZRIhCh1DQVBBQklMSVRZX1NPVVJDRV9VTlNQRUNJRklFRBAAEh4KGkNBUEFCSUxJVFlfU09VUkNFX1BMQVRGT1JNEAESHgoaQ0FQQUJJTElUWV9TT1VSQ0VfTEVHQUxJVFkQAhIZChVDQVBBQklMSVRZX1NPVVJDRV9PUkcQAxIeChpDQVBBQklMSVRZX1NPVVJDRV9PVkVSUklERRAEQk9aTWdpdGh1Yi5jb20vRXZlblBsYXkvZXZlbnBsYXktbW9uby9saWJzL3Byb3Rvcy9wa2cvY2FwYWJpbGl0eS92MTtjYXBhYmlsaXR5X3YxYgZwcm90bzM");

/**
 * CapabilityState is the resolved decision for one capability, surfaced on both
 * the bay_session GetStationConfigResponse (Wave E) and the core-internal
 * DiscoverBayResponse (Wave D).
 *
 * @generated from message evenplay.capability.v1.CapabilityState
 */
export type CapabilityState = Message<"evenplay.capability.v1.CapabilityState"> & {
  /**
   * @generated from field: evenplay.capability.v1.Capability capability = 1;
   */
  capability: Capability;

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;

  /**
   * @generated from field: evenplay.capability.v1.CapabilitySource source = 3;
   */
  source: CapabilitySource;
};

/**
 * Describes the message evenplay.capability.v1.CapabilityState.
 * Use `create(CapabilityStateSchema)` to create a new message.
 */
export const CapabilityStateSchema: GenMessage<CapabilityState> = /*@__PURE__*/
  messageDesc(file_capability, 0);

/**
 * Capability — the product-level functionality a bay can support (SMG-3174,
 * design §3). This is the client-facing, type-safe mirror of the DB
 * capability_registry, which remains the source of truth for the set and
 * carries each capability's jurisdiction_gated flag.
 *
 * @generated from enum evenplay.capability.v1.Capability
 */
export enum Capability {
  /**
   * @generated from enum value: CAPABILITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CAPABILITY_SKILL_STRIKE = 1;
   */
  SKILL_STRIKE = 1,

  /**
   * @generated from enum value: CAPABILITY_REAL_MONEY_GAMING = 2;
   */
  REAL_MONEY_GAMING = 2,

  /**
   * @generated from enum value: CAPABILITY_FULL_SWING_POINTS = 3;
   */
  FULL_SWING_POINTS = 3,

  /**
   * @generated from enum value: CAPABILITY_TOURNAMENTS = 4;
   */
  TOURNAMENTS = 4,
}

/**
 * Describes the enum evenplay.capability.v1.Capability.
 */
export const CapabilitySchema: GenEnum<Capability> = /*@__PURE__*/
  enumDesc(file_capability, 0);

/**
 * CapabilitySource identifies which resolution layer decided a capability's
 * final state (design §7), mirroring the engine's capability.Source
 * {PLATFORM, LEGALITY, ORG, OVERRIDE}.
 *
 * @generated from enum evenplay.capability.v1.CapabilitySource
 */
export enum CapabilitySource {
  /**
   * @generated from enum value: CAPABILITY_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CAPABILITY_SOURCE_PLATFORM = 1;
   */
  PLATFORM = 1,

  /**
   * @generated from enum value: CAPABILITY_SOURCE_LEGALITY = 2;
   */
  LEGALITY = 2,

  /**
   * @generated from enum value: CAPABILITY_SOURCE_ORG = 3;
   */
  ORG = 3,

  /**
   * @generated from enum value: CAPABILITY_SOURCE_OVERRIDE = 4;
   */
  OVERRIDE = 4,
}

/**
 * Describes the enum evenplay.capability.v1.CapabilitySource.
 */
export const CapabilitySourceSchema: GenEnum<CapabilitySource> = /*@__PURE__*/
  enumDesc(file_capability, 1);

